import { render, staticRenderFns } from "./itemNmContainer.vue?vue&type=template&id=24406330&"
import script from "./itemNmContainer.vue?vue&type=script&lang=js&"
export * from "./itemNmContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports